import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6a6 6 0 0 0-1.839-4.322L11.5 3H10V.343a5.998 5.998 0 0 0-4 0V3H4.5l-.661-1.323A6.004 6.004 0 0 0 2 6H1v2h14V6h-1Zm-6 8c-1.136 0-2.113-.56-2.836-1.489C4.434 11.571 4 10.291 4 9H2c0 1.71.567 3.429 1.586 4.739C4.613 15.059 6.136 16 8 16c1.864 0 3.387-.94 4.414-2.261C13.434 12.429 14 10.709 14 9h-2c0 1.29-.433 2.571-1.164 3.511C10.113 13.441 9.136 14 8 14Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Zastroishik16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var Zastroishik16 = createIcon(IconComponent);